import React, { useState, forwardRef, useEffect } from "react";
import styles from "./ContactsPopup.module.css";
import emptyImage from "../../assets/ImageEmpty.svg";
import { ReactComponent as PlusIconGray } from "../../assets/plusIconGray.svg";
import { useDispatch, useSelector } from "react-redux";
import { getAllContacts, getContactImage } from "../../../../actions/contacts";
import { getAllAssets } from "../../../../actions/assets";
import { useTranslation } from "react-i18next";
import { setAsset } from "@src/slices/assetsSlices";
import { clearContact, setFatherNewContact } from "../../../../slices/contactsSlices";
import { setFatherNewAsset } from "../../../../slices/assetsSlices";


const ContactsPopup = forwardRef(
  ({ handleContactClick,
    handleAssetClick, 
    // setShowNewContact, 
    type, 
    inputValue,
    setNewContact, 
    setNewAsset,
    handleSelectItem,
    customStyle,
    handleClickFocus,
    father
  }, ref) => {
    const dispatch = useDispatch();
    const { contacts } = useSelector((state) => state.contacts);
    const { t } = useTranslation("Assets");
    const { assets } = useSelector((state) => state.assets);
    const [contactImages, setContactImages] = useState({});
    const [contactsAssetsContainer, setContactsAssetsContainer ] = useState([])
    const [falloCarga, setFalloCarga] = useState(false)

    function ordenarAlfabeticamente(array) {
  return array.sort((a, b) => {
    const nombreA = (a.contactName || a.name || '').toLowerCase();
    const nombreB = (b.contactName || b.name || '').toLowerCase();
    return nombreA.localeCompare(nombreB);
  });
}

    useEffect(()=> {
      let contactsAndAssetsArray = [...assets.slice(0,2),...contacts.slice(0,2)]
      setContactsAssetsContainer(ordenarAlfabeticamente(contactsAndAssetsArray))

    },[contacts,assets])

    useEffect(() => {
      dispatch(getAllAssets({
        search: inputValue,
        limit: 3,
      }));

      dispatch(
        getAllContacts({
          search: inputValue,
          limit: 3,
        })
      );
    }, [dispatch, inputValue]);

    useEffect(() => {
      const fetchImages = async () => {
        const imageMap = {};
        for (const contact of contacts) {
          try {
            const response = await dispatch(getContactImage({ contactId: contact._id }));
            imageMap[contact._id] = response.payload.image; 
          } catch (err) {
            console.error(`Error al cargar imagen del contacto ${contact._id}:`, err);
          }
        }
        setContactImages(imageMap);
      };

      if (contacts.length > 0) {
        fetchImages();
      }
    }, [contacts]);

    return (
      <div className={styles.contacts} ref={ref} style={{...customStyle}}>
        {type === "contact" ? (
          contacts.map((contact) => (
            <div
              key={contact._id}
              className={styles.contact}
              onMouseDown={() => handleContactClick(contact)}
            >
              <img
                src={contactImages[contact._id] || emptyImage}
                width={30}
                height={30}
                alt=""
              />
              <div>
                <p>{contact.contactName}</p>
                <span>
                  {contact.companyEmail}
                </span>
              </div>
            </div>
          ))
        ) : type === "asset" ? (
          assets.map((asset) => (
            <div
              key={asset._id}
              className={styles.asset}
              onMouseDown={() => handleAssetClick(asset)}
            >
              <img
                src={asset.image || emptyImage}
                width={30}
                height={30}
                alt=""
              />
              <div>
                <p>{asset.name}</p>
                <span>{asset.description}</span>
              </div>
            </div>
          ))
        ) : type === "chat" ? (
          contactsAssetsContainer.map((item) => (
            <div
              key={item._id}
              className={`${styles.asset} ${styles.chatCard}`}
              onMouseDown={() => {
                handleSelectItem(item)
                setTimeout(() => {
                handleClickFocus();
              }, 0);
              }
              }
            >
              <img style={{borderRadius: falloCarga ? "0px": item.image ? "999px":"0px"}}
                src={item.image || emptyImage}
                width={30}
                height={30}
                alt=""
                  onError={(e) => {
                    setFalloCarga(true)
                   e.target.onerror = null;
                  e.target.src = emptyImage;
                  }}
              />
              <div>
                <p>{item.name ? item.name : item.contactName ? item.contactName : "category" in item ? "Nombre del Activo": "contactName" in item ? "Nombre de la cuenta": ""}</p>
                <span>{item.description ? item.description : item.companyEmail? item.companyEmail: "category" in item ? 'Descripción' : "contactName" in item ? 'Email adress, dirección' : ""}</span>
              </div>
            </div>
          ))
        ) : null}
      {(type === 'asset' && father !== 'newAsset' || type === 'contact') && 
        <div
          className={styles.newContactInfoClient}
          onClick={() => { 
            if(type === 'contact'){
            dispatch(clearContact());
            dispatch(setFatherNewContact('panel'))
            setNewContact(true)
            } else if (type === 'asset'){
            dispatch(setAsset(null))
            dispatch(setFatherNewAsset('panel'))
            setNewAsset(true)
            }
          }}
        >
          {type === 'asset'? <PlusIconGray /> : type === 'contact'? <PlusIconGray /> : ""}
          {type === 'asset'? t('newAsset'): type === 'contact'? t('newContact') : ""}
        </div>}
      </div>
    );
  }
);

export default ContactsPopup;
